import { Box } from '@mui/material';
import React from 'react';

import { CenterCellContainer } from './CenterCellContainer';
import { REMINDER_COLORS } from 'FRONTEND/utils/constants';

export const CellColorCircle = ({ color }: { color: string }) => {
  const hex = REMINDER_COLORS[color];
  return <CenterCellContainer><Box sx={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: hex }} /></CenterCellContainer>;
};
